module.exports = __webpack_public_path__ + "img/benefit_presale-opportunities.f5e70832.jpg";